import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

import styles from "./Button.module.scss";

const Button = ({
  isAccent,
  isBlack,
  isSmall,
  withoutHover,
  isActive,
  className,
  to,
  href,
  target,
  onClick,
  children,
  ...rest
}) => {
  const style = classNames(
    className,
    styles.Button,
    isAccent && styles.Accent,
    isSmall && styles.Small,
    isActive && styles.Active,
    isBlack && styles.Black,
    withoutHover && styles.WithoutHover
  );

  if (href && target) {
    return (
      <a
        className={style}
        href={href}
        target={target}
        rel={target === "_blank" ? "noreferrer" : null}
        {...rest}
      >
        {children}
      </a>
    );
  }

  if (to) {
    return (
      <Link className={style} to={to} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <button
      className={style}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
